import { useTranslation } from "react-i18next";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";
import { AppTester } from "../../../../supporting";

export const useGetTagTabs = () => {

    const { t } = useTranslation();
    const isMediiiaNature = AppTester.isMediiiaNature();
    const isStartHSE = AppTester.isStartHSE();
    const isHseSpacePro = AppTester.isContext('s-pro')

    return {
        [NAVBAR_TAB_NAMES.themes]: {
            content: t('nav.themes'),
            linkTo: '/competencies',
            desktopOnly: true
        },
        [NAVBAR_TAB_NAMES.competencies]: {
            content: t('nav.competencies'),
            linkTo: '/competencies',
            desktopOnly: true
        },
        [NAVBAR_TAB_NAMES.tags]: {
            content: () => {
                if (isStartHSE) {
                    return t("nav.educational_profiles")
                }
                if (isMediiiaNature) {
                    return t("nav.choose_date")
                }
                return t("nav.tags")
            },
            linkTo: isHseSpacePro ? `${process.env.REACT_APP_URL_HSE_SPACE}/tags` :'/tags',
            desktopOnly: true
        },
    }
}import { useTranslation } from "react-i18next";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";
import { AppTester } from "../../../../supporting";

export const useGetTagTabs = () => {

    const { t } = useTranslation();
    const isMediiiaNature = AppTester.isMediiiaNature();
    const isStartHSE = AppTester.isStartHSE();
    const isHseSpacePro = AppTester.isContext('s-pro')

    return {
        [NAVBAR_TAB_NAMES.themes]: {
            content: t('nav.themes'),
            linkTo: '/competencies',
            desktopOnly: true
        },
        [NAVBAR_TAB_NAMES.competencies]: {
            content: t('nav.competencies'),
            linkTo: '/competencies',
            desktopOnly: true
        },
        [NAVBAR_TAB_NAMES.tags]: {
            content: () => {
                if (isStartHSE) {
                    return t("nav.educational_profiles")
                }
                if (isMediiiaNature) {
                    return t("nav.choose_date")
                }
                return t("nav.tags")
            },
            linkTo: isHseSpacePro ? `${process.env.REACT_APP_URL_HSE_SPACE}/tags` :'/tags',
            desktopOnly: true
        },
    }
}